import { render, staticRenderFns } from "./SettingsConfigs.vue?vue&type=template&id=4fd0575f"
import script from "./SettingsConfigs.vue?vue&type=script&lang=js"
export * from "./SettingsConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports